import React from 'react';
import ReactDom from 'react-dom';
import KatlaContent from './KatlaContent';

export default class KatlaEditor extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            ready: 0,
            step: 0,
            variants: [],
            selected: {},
            attributeMap: [],
            optionsMap: {},
            availableVariants: [],
            parentProduct: null,
            isHovered: false
        }

        this.quantityInput = React.createRef();

    }

    componentDidMount(){

        let variants = JSON.parse( document.getElementById('catla-params').getAttribute('data-variants'));
        let atribMap = JSON.parse( attributeMap );
        
        var url_string = window.location.href;
        var url = new URL(url_string);
        var selected = {};

        for( let i=0; i < atribMap.length; i++ ){

            let atribVal = url.searchParams.get('attribute_' + atribMap[i].name);

            if( atribVal )
                selected[atribMap[i].name] = atribVal;

        }
        let step = Object.keys( selected ).length;
        let filteredVariants = this.recalculateAvailableVariantsFromScratch( selected, variants );

        this.setState( { step, parentProduct: productID, variants: variants, availableVariants: filteredVariants, attributeMap: atribMap, ready: 1, selected } );
        
    }


    getMaxPrice(){

        let price = 0;
        let priceHTML = this.state.availableVariants[0].price_html;
        this.state.availableVariants.forEach( ( elem )=>{

            if( elem.display_price > price ){
                price = elem.display_price;
                priceHTML = elem.price_html;
            }
            
        } );

        return priceHTML;

    }

    getMinPrice(){

        let price = this.state.availableVariants[0].display_price;
        let priceHTML = this.state.availableVariants[0].price_html;
        this.state.availableVariants.forEach( ( elem )=>{

            if( elem.display_price < price ){
                price = elem.display_price;
                priceHTML = elem.price_html;
            }
        });

        return priceHTML;

    }

    displayPrice(){

        if( this.state.attributeMap.length == Object.keys( this.state.selected ).length ){

            return (
                <div className="catla-price finall">
                    <span dangerouslySetInnerHTML={{__html : this.state.availableVariants[0].price_html}} />
                </div>
            );

        }else {

            if( this.state.availableVariants.length == 1 ){
                
                return (
                    <div className="catla-price">
                        <span dangerouslySetInnerHTML={{__html : this.state.availableVariants[0].price_html}} />
                    </div>
                );
            }else {

                return (
                    <div className="catla-price">
                        <span dangerouslySetInnerHTML={{__html : this.getMinPrice()}} /> - <span dangerouslySetInnerHTML={{__html : this.getMaxPrice()}} />
                    </div>
                );

            }

        }

    }

    renderCurrentStep(){

        if( this.state.attributeMap.length > this.state.step ){

            return (
                <div>
                    {this.displayPrice()}
                    <div className="catla-editor-select-title"><span className="catla-editor_stepcount">{this.state.step+1}/{this.state.attributeMap.length}</span>{ this.state.attributeMap[this.state.step].label }</div>
                    {this.renderOptions()}
                </div>
            );

        } else {

            return (
                <div>
                    <div className="catla-editor_optionsContainer">
                        <div className="fixed-content">
                            {this.renderSelected()}
                        </div>
                    </div>
                    {this.displayPrice()}
                    {this.renderAddToCartButton()}
                </div>
            );

        }

    }

    renderAddToCartButton(){

        return(
            <form action={window.location.href} method="POST" encType="multipart/form-data">
                <div className="quantity">
                    <input type="number" ref={this.quantityInput} className="input-text qty text" step="1" min="1" max="" name="quantity" defaultValue="1" title="Szt." size="4" pattern="[0-9]*" inputmode="numeric" aria-labelledby="ilość Katla test"/>
                </div>
                <button type="submit" className="single_add_to_cart_button button alt">{editor_translation['add-to-cart']}</button>
                <input type="hidden" name="add-to-cart" value={this.state.parentProduct}/>
                <input type="hidden" name="product_id" value={this.state.parentProduct}/>
                <input type="hidden" name="variation_id" className="variation_id" value={this.state.availableVariants[0].variation_id}/>
            </form>
        );        

    }

    prevState(){

        let selected = JSON.parse( JSON.stringify( this.state.selected ) );
        
        let keyToRemove = this.state.attributeMap[ this.state.step-1 ].slug;

        delete selected[ keyToRemove ];

        let step = this.state.step-1;
        let availableVariants = this.recalculateAvailableVariantsFromScratch( selected );

        this.setState({ step, selected, availableVariants });

    }

    renderNav(){

        if( this.state.step > 0 ){

            return (
                <div className="previous-editor-step">
                    <span onClick={ this.prevState.bind( this )}>{editor_translation.change} { this.state.attributeMap[ this.state.step-1 ].label }</span>
                </div>
            );

        }

    }

    recalculateAvailableVariantsFromScratch( selectedOptions, variants ){

        let _variants = variants || this.state.variants;

        let availableVariants = _variants.filter( ( elem ) => {

            let keys = Object.keys( selectedOptions );
            let available = true;

            for( let i=0; i < keys.length; i++ ){

                if( elem.attributes.hasOwnProperty( keys[i] ) || elem.attributes.hasOwnProperty(  'attribute_'+ keys[i] ) ){

                    let attribVal = elem.attributes.hasOwnProperty( keys[i] ) ? elem.attributes[ keys[i] ] : elem.attributes[ 'attribute_'+ keys[i] ];

                    if( selectedOptions[keys[i]] != attribVal ){
                        available = false;
                    }
                    
                }else {

                    available = false;

                }
                
            }
            
            return available;

        });

        return availableVariants;

    }

    selectOption( e ){

        e.stopPropagation();

        let selectedParent = e.target.getAttribute( 'data-parent-slug' );
        let selectedOption = e.target.getAttribute( 'data-slug' );

        let availableVariants = this.state.availableVariants.filter( ( elem ) => {

            if( elem.attributes.hasOwnProperty( selectedParent ) || elem.attributes.hasOwnProperty(  'attribute_'+ selectedParent ) ){

                let attribVal = elem.attributes.hasOwnProperty( selectedParent ) ? elem.attributes[ selectedParent ] : elem.attributes[ 'attribute_'+ selectedParent ];
                
                if( attribVal == selectedOption )
                    return true;
                else {
                    return false;
                }
            }

        });

        let oldSelection = JSON.parse( JSON.stringify( this.state.selected ) );
        oldSelection[ selectedParent ] = selectedOption;

        this.setState( {step: this.state.step+1, availableVariants, selected: oldSelection } );
        
    }

    collectAvailableAttributeOptions( attributeName ){

        let options = [];

        this.state.availableVariants.forEach( ( elem ) => {

            let attributeOption = elem.attributes.hasOwnProperty( attributeName ) ? elem.attributes[ attributeName] : elem.attributes[ 'attribute_'+ attributeName ];
            
            if( options.indexOf( attributeOption ) == -1 )
                options.push( attributeOption );

        });

        return options;

    }

    simulateStepImage( e ){

        let slug = e.target.getAttribute('data-slug');
        let parent = e.target.getAttribute('data-parent-slug');
        this.setState({ isHovered: {parent, slug } });

    }

    stopSimulating (){
        this.setState({ isHovered: false });
    }

    renderOptions(  ){

        let options = [];
        
        let currentAttribute = JSON.parse( JSON.stringify( this.state.attributeMap[this.state.step] ));
        
            let availableOptions = this.collectAvailableAttributeOptions( currentAttribute.slug );

            currentAttribute.options = currentAttribute.options.filter( ( elem ) => {

                if( availableOptions.indexOf( elem.slug ) > -1 ){
                    return true;
                }else {
                    return false;
                }

            });

            options = currentAttribute.options.map( ( elem ) => {

                if( elem.imageSrc ){

                    return (

                        <div className="catla-editor-attribute-option">
                            <div onMouseLeave={this.stopSimulating.bind(this)} onMouseOver={ this.simulateStepImage.bind( this )} onClick={ this.selectOption.bind( this ) } style={ {'backgroundImage': 'url(' + elem.imageSrc + ')' } } className="attributeOption" data-parent-slug={ currentAttribute.slug } data-slug={ elem.slug }>
                            </div>
                            <h4>{elem.name}</h4>
                        </div>
                    
                    );

                } else {

                    return (
                        <div className="catla-editor-attribute-option">
                            <div onMouseLeave={this.stopSimulating.bind(this)} onMouseOver={ this.simulateStepImage.bind( this )} onClick={ this.selectOption.bind( this ) } className="attributeOption no-image" data-parent-slug={ currentAttribute.slug } data-slug={ elem.slug }>
                                <div></div>
                            </div>
                            <h4>{elem.name}</h4>
                        </div>
                    );

                }

            });

        
        return (
            <div className="row available-options">
                <div class="col">
                    {options}
                </div>
            </div>
        );

    }

    renderSelected(){

        let selected = [];

        Object.keys(this.state.selected).forEach( ( elem ) => {

            let attributeObj = this.state.attributeMap.find( ( _e ) => {
                if( _e.slug == elem )
                    return true;
            });

            let option = attributeObj.options.find(( _e )=>{
                return this.state.selected[elem] == _e.slug;
            });

            selected.push({
                'attribute_name' : attributeObj.label,
                'option_name' : option.name,
                'option_image' : option.imageSrc
            });

        });

        let items = selected.map( ( elem ) => {

            let image = null;

            if( elem.option_image ){
                image = <div className="option-image" style={{ 'backgroundImage' :'url(' + elem.option_image + ')' } } />
            }else {
                image = <div className="option-image" />
            }

            return (
                <div className="catla-editor-single-option">
                    {image}
                    <span className="option-title">{elem.attribute_name}</span>
                    <span className="option-value">{elem.option_name}</span>
                </div>
            );

        });

        return items;

    }

    renderImage(){

        let firstAvailable = this.state.availableVariants[0];

            if( this.state.attributeMap.length == Object.keys( this.state.selected ).length ){
                return (
                    <div>
                        <h2 className='catla-editor-title'>{editor_translation['your-project']}</h2>
                        <KatlaContent 
                            image={firstAvailable.image.src} 
                            text={firstAvailable.variation_description}  
                        />
                    </div>
                );
            } else {
                
                
                if( this.state.isHovered ){
                    
                    let variants = this.state.variants;
                    let attribMap = this.state.attributeMap;
                    let selected = JSON.parse( JSON.stringify( this.state.selected ) );
                    selected[ this.state.isHovered.parent ] = this.state.isHovered.slug;
                    let filteredVariants = this.recalculateAvailableVariantsFromScratch( selected, this.state.variants );
                    
                    return (
                        <div>
                            <h2 className='catla-editor-title'>Katla<span>{editor_translation['your-composition']}</span></h2>

                            <KatlaContent 
                                image={filteredVariants[0].image.src} 
                                text={filteredVariants[0].variation_description}  
                            />
                            
                        </div>
                    );

                } else {
                    return (
                        <div>
                            <h2 className='catla-editor-title'>Katla<span>twoja kompozycja</span></h2>

                            <KatlaContent 
                                image={firstAvailable.image.src} 
                                text={firstAvailable.variation_description}  
                            />
                            
                        </div>
                    );
                }
            }
        
    }

    render(){
        
        if( this.state.ready ){
            
            return (
                <div className="row catla-editor">
                    <div className="col-12">
                        
                        {this.renderImage()}
                        {this.renderCurrentStep()}
                        {this.renderNav()}
                    </div>
                </div>
            );
        } else {
            return (<h1>Ładowanie :)</h1>);
        }

    }

}